const portfolio = [
  {
    id: 1,
    img: "./img/nawdown-portfolio.svg",
    title: "Branding, Web Development",
    desc: `NewDawn Support Services`,
    url: "https://newdawnsupportservices.com.au/",
    category: "website",
  },
  {
    id: 2,
    img: "./img/goriite-portfolio.svg",
    title: "Branding, Design, Software, Marketing ",
    desc: `Goriite Digital Agency`,
    url: "https://goriite.com/",
    category: "website",
  },
  {
    id: 3,
    img: "./img/giftedhands-portfolio.svg",
    title: "Brand setup, Web Development",
    desc: `Gifted Hands Support`,
    url: "https://giftedhands.net.au/",
    category: "website",
  },

  {
    id: 4,
    img: "./img/portfolio-19.svg",
    title: "Code Authentication Library, Landing Page",
    desc: `Design, Teamwork`,
    url: "https://authwiki.netlify.app/",
    category: "website",
  },
  {
    id: 5,
    img: "./img/portfolio-4.svg",
    title: "UIUX, Product Design",
    desc: `Pronto Mobile App`,
    url: "",
    category: "UI/UX",
  },
  {
    id: 6,
    img: "./img/portfolio-5.svg",
    title: "UIUX, Product Design, Onboarding",
    desc: `Fintech Mobile App`,
    url: "",
    category: "UI/UX",
  },
  {
    id: 7,
    img: "./img/portfolio-6.svg",
    title: "UIUX, Product Design, Onboarding",
    desc: `Fintech Mobile App`,
    url: "",
    category: "UI/UX",
  },
  {
    id: 8,
    img: "./img/portfolio-13.svg",
    title: "Brand Labelling",
    desc: `Design, Branding`,
    url: "",
    category: "logo",
  },
  {
    id: 9,
    img: "./img/portfolio-8.svg",
    title: "Flyer, Event",
    desc: `Advertisement, Marketing`,
    url: "",
    category: "logo",
  },
  {
    id: 10,
    img: "./img/portfolio-9.svg",
    title: "Profile Card",
    desc: `Personal Brand`,
    url: "",
    category: "brand",
  },
  {
    id: 11,
    img: "./img/portfolio-10.svg",
    title: "Business Card",
    desc: `Brand Assets`,
    url: "",
    category: "brand",
  },
  {
    id: 12,
    img: "./img/portfolio-11.svg",
    title: "Mockup Hoodie",
    desc: `Design, Branding`,
    url: "",
    category: "brand",
  },
  ,
  {
    id: 13,
    img: "./img/portfolio-12.svg",
    title: "Logo/Brand identity",
    desc: `Design, Brand Setup`,
    url: "",
    category: "brand",
  },
  {
    id: 14,
    img: "./img/portfolio-7.svg",
    title: "Logo/Identity",
    desc: `Branding`,
    url: "",
    category: "brand",
  },
  {
    id: 15,
    img: "./img/portfolio-14.svg",
    title: "Landing Page, Web Design",
    desc: `Travel Agency`,
    category: "UI/UX",
  },
  {
    id: 16,
    img: "./img/portfolio-15.svg",
    title: "Mobile Responsiveness, web Design",
    desc: `Travel Agency`,
    url: "",
    category: "UI/UX",
  },
  {
    id: 17,
    img: "./img/portfolio-16.svg",
    title: "Brand Identity/Logo",
    desc: `Design, Branding`,
    url: "",
    category: "logo",
  },
  {
    id: 18,
    img: "./img/portfolio-17.svg",
    title: "Branded Backpack",
    desc: `Design, Branding`,
    url: "",
    category: "brand",
  },
  {
    id: 19,
    img: "./img/portfolio-18.svg",
    title: "Branded Backpack",
    desc: `Design, Branding`,
    url: "",
    category: "brand",
  },
];
export default portfolio;
